














































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import RadioCard from '@/modules/shared/components/shared/kit/RadioCard.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import { OwnBankInfoModel, PaymentMethods } from '@/modules/transaction/models/payment.model'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import PaymentBankInfo from '@/modules/transaction/components/shared/payment/PaymentBankInfo.vue'

@Component({
  components: { PaymentBankInfo, MediaUploader, RadioCard, BaseCard }
})
export default class PaymentType extends Vue {

  @PropSync('paymentMethodData', { required: true }) paymentMethod!: PaymentMethods
  @PropSync('bankReceiptImageData', { required: true }) bankReceiptImage!: Array<File>
  @Prop() payable!: number
  @Prop() ownBankInfo!: OwnBankInfoModel

  @Prop({ default: true }) online!: boolean
  @Prop({ default: true }) wallet!: boolean
  @Prop({ default: true }) card!: boolean

  private PAYMENTMETHODS = PaymentMethods

  get walletAmount() {
    return this.$page.props.wallet_amount
  }

  setBankReceiptImage(value) {
    this.bankReceiptImage = value
  }
}
